"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TvHighVoltage = void 0;
const react_1 = __importDefault(require("react"));
const tv_high_voltage_1 = __importDefault(require("../icons-path/tv-high-voltage"));
const icons_svg_1 = require("../icons-svg");
require("../icons.types");
const TvHighVoltage = (props) => {
    return react_1.default.createElement(icons_svg_1.IconsSvg, Object.assign({}, props, { path: tv_high_voltage_1.default }));
};
exports.TvHighVoltage = TvHighVoltage;
